import { api } from "lib/graphql/api"
import { gql } from "@apollo/client"
import { query } from "lib/graphql/query"

export const getClientSessions = api(async function getClientSessions(client) {
    return query(
        gql`
            query getClientSessions($client: String) {
                getClientSessions(client: $client)
            }
        `,
        { client },
        { returns: "getClientSessions" }
    )
})

export const getClientStats = api(async function getClientStats(client) {
    console.log(`calling getClientStats with client ${client}`)
    return await query(
        gql`
            query getClientStats($client: String) {
                getClientStats(client: $client)
            }
        `,
        { client },
        { returns: "getClientStats" }
    )
})
